import type { ReduxStateType } from 'Core/store';
import { createSearchItemDataCollectionSelector } from 'Modules/selectors';

export const localStorageSelector = (state: ReduxStateType): ReduxStateType['localStorage'] =>
  state.localStorage;

export const comparedItemsSelector = createSearchItemDataCollectionSelector(
  localStorageSelector,
  (localStorage) => localStorage.compared,
);
